export const isNil = (value: unknown): boolean => {
  return value === null || value === undefined;
};